import { render } from "./DonnePersonnellePage.vue?vue&type=template&id=59cef045"
import script from "./DonnePersonnellePage.vue?vue&type=script&lang=js"
export * from "./DonnePersonnellePage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__